import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrHouseRuleDisallowed.ts
var t = () => e("houseRuleDisallowed");
//#endregion
export { t as useTrHouseRuleDisallowed };
